import { adminUsersApi } from '#entities';
import { resourceUpdated } from '#shared';

import type { AppDispatch } from '#shared';
import type { PresenceFrame } from './serverMessage';

/**
 * Applies a presence SNAPSHOT to the roster cache: set membership decides
 * `online` for EVERY row, both directions in one pass — wholesale replacement,
 * never a merge. Idempotent by construction, so a missed or repeated frame
 * self-corrects on the next one (the BE re-sends a snapshot on reconnect).
 *
 * If the roster query has never run, updateQueryData is a no-op — correct:
 * the REST fetch on page mount carries current truth. `lastSeenAt` is NOT
 * touched (frames do not carry it); the page's 60s poll refreshes it.
 */
export const applyPresenceFrame = (
  frame: PresenceFrame,
  dispatch: AppDispatch,
): void => {
  const online = new Set(frame.onlineOids);
  dispatch(
    adminUsersApi.util.updateQueryData('getAdminUsers', undefined, draft => {
      for (const row of draft) {
        row.online = online.has(row.oid);
      }
    }),
  );
  dispatch(resourceUpdated({ resource: 'adminUsers', atMs: Date.now() }));
};
